
@if (isLoading$ | async) {
    <div class="spinner-container">
        <nz-spin 
            [nzSpinning]="true"
            [nzSize]="'large'">
        </nz-spin>
    </div>
}